import { Node } from '@tiptap/core';
import { mergeAttributes } from '@tiptap/core';
export const OutputSizes = Node.create({
    name: 'outputSize',
    group: 'block',
    draggable: true,
    atom: true,
    addAttributes() {
        return {
            outputSizes: {
                default: [],
                renderHTML(attrs) {
                    return { 'data-output-sizes': attrs.outputSizes.join(',') };
                },
                parseHTML(element) {
                    const outputSizes = element.getAttribute('data-output-sizes');
                    return outputSizes?.split(',') ?? [];
                },
            },
        };
    },
    addCommands() {
        return {
            setOutputSizes: () => ({ commands }) => {
                return commands.insertContent({ type: this.name });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: 'mb-output-sizes',
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return ['mb-output-sizes', mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=output-sizes.js.map